/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_Pain_NewInputs */

const en_us2_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pain and injuries · new`)
};

const pt_br2_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores e lesões · nova`)
};

const es_419_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolores y lesiones · nuevo`)
};

const pt_pt2_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dores e lesões · nova`)
};

const fr_fr2_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Douleurs et blessures · nouvelle`)
};

const de_de2_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmerzen und Verletzungen · neu`)
};

const it_it2_profile_editors_eyebrow_pain_new = /** @type {(inputs: Profile_Editors_Eyebrow_Pain_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolori e infortuni · nuovo`)
};

/**
* | output |
* | --- |
* | "Pain and injuries · new" |
*
* @param {Profile_Editors_Eyebrow_Pain_NewInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_pain_new = /** @type {((inputs?: Profile_Editors_Eyebrow_Pain_NewInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_Pain_NewInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_pain_new(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_pain_new(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_pain_new(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_pain_new(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_pain_new(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_pain_new(inputs)
	return en_us2_profile_editors_eyebrow_pain_new(inputs)
});
export { profile_editors_eyebrow_pain_new as "profile-editors.eyebrow_pain_new" }